const TenantStatus = {
    ACTIVE: "ACTIVE",
    ARCHIVED: "ARCHIVED"
}

export default TenantStatus;